import { combineReducers } from 'redux'

import resultados from './gruposContabeis'

export default combineReducers({ resultados })
